var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "payment",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.588,
    height: 64.351,
    viewBox: "0 0 65.588 64.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.246,59.666H33.3L62.56,30.4a6.314,6.314,0,0,0,0-8.933L42.885,1.792a6.465,6.465,0,0,0-8.935,0L3.029,32.712a6.315,6.315,0,0,0,0,8.933l4.212,4.213,0,.005.005,0,13.8,13.8H2.342a2.342,2.342,0,0,0,0,4.685h60.9a2.342,2.342,0,1,0,0-4.685Zm-3.52-33.73a1.62,1.62,0,0,1-.478,1.153L28.326,58.009a1.67,1.67,0,0,1-2.308,0l-13.8-13.8,33.229-33.23,13.8,13.805a1.622,1.622,0,0,1,.478,1.155ZM5.863,37.177a1.621,1.621,0,0,1,.478-1.153L37.263,5.1a1.632,1.632,0,0,1,2.308,0l2.56,2.56L8.9,40.893l-2.56-2.561a1.622,1.622,0,0,1-.478-1.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.914.658l-8.2,8.2a2.342,2.342,0,1,0,3.312,3.312l8.2-8.2A2.342,2.342,0,0,0,8.914.658Z",
    transform: "translate(25.738 37.441)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.6f71f750169bf60a0e0ea416d8aefb1a.svg";
export { ForwardRef as ReactComponent };